export default __webpack_public_path__ + "static/charles-4a313ff2f96aeec9b99a33e9e56abd02.png";